import { _ as _sliced_to_array } from "@swc/helpers/_/_sliced_to_array";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { Button } from "@faire/web--source/slate/Button";
import { Opacity } from "@faire/web--source/slate/Color";
import { Column, Flex } from "@faire/web--source/slate/Layout";
import { Modal } from "@faire/web--source/slate/Modal";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import React, { useState } from "react";
import styled from "styled-components";
var DottedUnderlineText = styled(Typography).withConfig({
    componentId: "sc-8602fa9a-0"
})([
    "text-decoration:underline;text-decoration-style:dotted;text-decoration-color:",
    ";text-underline-offset:3px;"
], Core.text.default + Opacity.O_50);
var ModalContentWrapper = styled(Column).withConfig({
    componentId: "sc-8602fa9a-1"
})([
    "padding:",
    ";width:100%;height:100%;"
], getSpacing(0, "3x"));
var ButtonContainer = styled(Column).withConfig({
    componentId: "sc-8602fa9a-2"
})([
    "flex-grow:1;"
]);
var FlexSpacer = styled(Flex).withConfig({
    componentId: "sc-8602fa9a-3"
})([
    "flex-grow:1;"
]);
export var MobileDottedTooltip = function(param) {
    var text = param.text, tooltipTitle = param.tooltipTitle, tooltipText = param.tooltipText, tooltipCTA = param.tooltipCTA, tooltipCTALink = param.tooltipCTALink;
    var _useState = _sliced_to_array(useState(false), 2), isModalOpen = _useState[0], setIsModalOpen = _useState[1];
    var openModal = function() {
        return setIsModalOpen(true);
    };
    var closeModal = function() {
        return setIsModalOpen(false);
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(DottedUnderlineText, {
                variant: "paragraphSansMedium",
                onClick: openModal,
                children: text
            }),
            /*#__PURE__*/ _jsx(Modal, {
                isOpen: isModalOpen,
                onClose: closeModal,
                contentStyle: {
                    height: "min-content",
                    alignSelf: "end"
                },
                padding: "0",
                children: /*#__PURE__*/ _jsxs(ModalContentWrapper, {
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "3x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            variant: "pageHeaderSerifRegular",
                            children: tooltipTitle
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "4x"
                        }),
                        /*#__PURE__*/ _jsx(Typography, {
                            children: tooltipText
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "4x"
                        }),
                        /*#__PURE__*/ _jsxs(ButtonContainer, {
                            children: [
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "tertiary",
                                    tertiaryColor: Core.surface.default,
                                    linkTo: tooltipCTALink,
                                    children: tooltipCTA
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    size: 12
                                }),
                                /*#__PURE__*/ _jsx(FlexSpacer, {}),
                                /*#__PURE__*/ _jsx(Button, {
                                    variant: "primary",
                                    onClick: closeModal,
                                    children: "Close"
                                })
                            ]
                        }),
                        /*#__PURE__*/ _jsx(Spacer, {
                            size: "4x"
                        })
                    ]
                })
            })
        ]
    });
};
